import React from "react";
import PropTypes from "prop-types";
import "./SwissBillingPaymentType.scss";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import PopoverButton from "app/pages/.shared/Popover/PopoverButton";
import DateSelectorInput from "app/pages/.shared/DateSelector/DateSelectorInput";
import get from "lodash/get";
import { SWISSBILLING_INVOICE_TYPES } from "app/constants";
import PictoRadio from "app/pages/.shared/PictoRadio";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";

class SwissBillingPaymentType extends React.PureComponent {
	render() {
		const { fields = {}, total, swissBillingCGVURL, maxAmount } = this.props;
		return (
			<div className="swissbilling-payment-type">
				<div className="swissbilling-payment-type__pay-amount">
					<FormattedMessage id="payment.pay.all.without.fees" />
					<span>
						<AmountContainer amount={total} />
					</span>
				</div>
				<div className="swissbilling-payment-type__info">
					<FormattedMessage
						id="swissbilling.info.paragraph"
						values={{
							popover: (
								<PopoverButton
									popOverButtonClassName="payment__popover__button"
									popOverClassName="payment__popover"
									popOverContainerClassName="swissbilling-payment-type__info__popover"
									popOverPosition="below"
									popOverContent={
										<div className="payment__popover--content">
											<div>
												<FormattedMessage
													id="swissbilling.info.popover.text"
													values={{
														cgvLink: (
															<a
																rel="noopener noreferrer"
																target="_blank"
																href={swissBillingCGVURL}
															>
																<FormattedMessage id="swissbilling.info.popover.cgv.label" />
															</a>
														),

														maxAmount: maxAmount,
													}}
												/>
											</div>
										</div>
									}
									buttonLabel={
										<IconInfo
											width={13}
											height={12}
											style={{ marginLeft: "10px" }}
										/>
									}
								/>
							),
						}}
					/>
				</div>
				<div className="swissbilling-payment-type__birthdate">
					<DateSelectorInput
						formatMonth="2-digit"
						label={<FormattedMessage id="swissbilling.birthdate.label" />}
						fields={fields.birthdate}
						id="swissbilling-birthdate"
						name="swissbilling-birthdate"
						isRequired
					/>
				</div>

				<div className="swissbilling-payment-type__invoice-type">
					<div className="swissbilling-payment-type__invoice-type__note">
						<FormattedMessage id="swissbilling.invoice.type.note" />
					</div>
					<div className="swissbilling-payment-type__invoice-type__radio-group">
						<div className="swissbilling-payment-type__invoice-type__radio-group__item">
							<PictoRadio
								field={fields.invoiceType}
								name={`swissbilling-invoiceType`}
								id={`swissbilling-invoiceType-${SWISSBILLING_INVOICE_TYPES.EMAIL}`}
								value={SWISSBILLING_INVOICE_TYPES.EMAIL}
								checked={
									get(fields, "invoiceType.value") ===
									SWISSBILLING_INVOICE_TYPES.EMAIL
								}
								icon={<i className="icon icon--email-grey" />}
								label={<FormattedMessage id="swissbilling.invoice.type.email" />}
							/>
						</div>
						<div className="swissbilling-payment-type__invoice-type__radio-group__item">
							<PictoRadio
								field={fields.invoiceType}
								name={`swissbilling-invoiceType`}
								id={`swissbilling-invoiceType-${SWISSBILLING_INVOICE_TYPES.PAPER}`}
								value={SWISSBILLING_INVOICE_TYPES.PAPER}
								checked={
									get(fields, "invoiceType.value") ===
									SWISSBILLING_INVOICE_TYPES.PAPER
								}
								icon={<i className="icon icon--mail" />}
								label={<FormattedMessage id="swissbilling.invoice.type.paper" />}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

SwissBillingPaymentType.propTypes = {
	fields: PropTypes.object,
	total: PropTypes.number,
	swissBillingCGVURL: PropTypes.string,
	maxAmount: PropTypes.string,
};

export default SwissBillingPaymentType;
